module.exports = __webpack_public_path__ + "img/slot.49173ba6.png";